export default __webpack_public_path__ + "static/media/UserIcon.66a250be.svg";